<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'新闻资讯'"></navBox>
			<!--导航-->
			<!--banner-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<img src="../../assets/img_public/news/banner01.webp" />
			</div>
			<!--banner-->
			<!--位置-->
			<div class="location_box">
				<div
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
					class="location_box_main"
				>
					<span @click="goHome" style="color: #333333;cursor: pointer;">首页</span>&ensp;/&ensp;<span>新闻资讯</span>&ensp;/&ensp;<span>{{ pageTitle }}</span>
				</div>
			</div>
			<!--位置-->
			<!--导航-->
			<div class="nav_box">
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
					class="nav_box_main"
				>
					<div
						v-for="(value, index) in navList"
						:key="index"
						class="nav_el"
						:class="isActived == index ? 'actived' : ''"
						@click="navChange(index)"
					>
						{{ value.title }}
					</div>
				</div>
			</div>
			<!--导航-->
			<!--公司动态-->
			<template v-if="isActived == 0">
				<gsdt></gsdt>
			</template>
			<!--公司动态-->
			<!--行业资讯-->
			<template v-if="isActived == 1">
				<hyzx></hyzx>
			</template>
			<!--行业资讯-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import gsdt from './gsdt/index_pc.vue'  //公司动态
import hyzx from './hyzx/index_pc.vue'  //行业资讯
export default {
	components:{
		navBox,
		footerBox,
		gsdt,
		hyzx
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
			isActived: 0,
			pageTitle: ''
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[2].children;
			switch(that.$route.params.newsId) {
				case 'dynamics.html':
					that.isActived = 0;
				break;
				case 'introduction.html':
					that.isActived = 1;
				break;
			}
			that.pageTitle = that.navList[that.isActived].title;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goHome() {
			this.$router.push({ path: '/' });
		},
		//nav变化
		navChange(index) {
			let that = this;
			that.isActived = index;
			that.pageTitle = that.navList[that.isActived].title;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//导航
	.nav_box{
		background-color: #f6f6f6;
		.nav_box_main{
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 50px;
			// text-align: center;
			.nav_el.actived{
				color: #C8000A;
				border: 1px solid #EEEEEE;
				border-radius: 8px;
			}
			.nav_el{
				display: inline-block;
				margin: 0 30px 0 0;
				padding: 10px 40px;
				font-size: 16px;
				cursor: pointer;
			}
		}
	}
	//位置
	.location_box{
		background-color: #f6f6f6;
		.location_box_main{
			width: 1200px;
			margin: 0px auto;
			padding: 40px 0;
			span{
				color: #999999;
			}
		}
	}
	//banner
	.banner_box{
		min-width: 1200px;
		img{
			width: 100%;
		}
	}
}
</style>